import { render, staticRenderFns } from "./GalleryForm.vue?vue&type=template&id=5da71efd&scoped=true&"
import script from "./GalleryForm.vue?vue&type=script&lang=js&"
export * from "./GalleryForm.vue?vue&type=script&lang=js&"
import style0 from "./GalleryForm.vue?vue&type=style&index=0&id=5da71efd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da71efd",
  null
  
)

export default component.exports